export const FILE_REPO_URL_DEV = "http://fgc-minio-fgc.apps.ocp.fifgroup.co.id";
export const FILE_REPO_URL_STG =
  "http://fgc-minio-new-fgc-test.apps.ocp.fifgroup.co.id";

export const IMPORT_TEMPLATE = {
  development: {
    MEMBER: `${FILE_REPO_URL_DEV}/template/template_member_import.csv`,
    DELIVER: `${FILE_REPO_URL_DEV}/issuance-import/template-issuancedelivery.xlsx`,
    GENERATOR_CUSTOMER: `${FILE_REPO_URL_DEV}/template/template_card_no_generator_deliver_to_customer.csv`,
    GENERATOR_BRANCH: `${FILE_REPO_URL_DEV}/template/template_card_no_generator_deliver_to_branch.csv`,
    RESERVATION: `${FILE_REPO_URL_DEV}/template/card_reservation_selected_branch.csv`,
    ZIPCODE: `${FILE_REPO_URL_DEV}/template/template_zip_import.csv`,
    ASSIGNMENT_MANUAL: `${FILE_REPO_URL_DEV}/template/create-manual-card-assignment.csv`,
    MANUAL_CHECK: `${FILE_REPO_URL_DEV}/template/template_import_manualcheck.csv`
  },
  staging: {
    MEMBER: `${FILE_REPO_URL_STG}/template/template_member_import.csv`,
    DELIVER: `${FILE_REPO_URL_STG}/issuance-import/template-issuancedelivery.xlsx`,
    GENERATOR_CUSTOMER: `${FILE_REPO_URL_STG}/template/template_card_no_generator_deliver_to_customer.csv`,
    GENERATOR_BRANCH: `${FILE_REPO_URL_STG}/template/template_card_no_generator_deliver_to_branch.csv`,
    RESERVATION: `${FILE_REPO_URL_STG}/template/card_reservation_selected_branch.csv`,
    ZIPCODE: `${FILE_REPO_URL_STG}/template/template_zip_import.csv`,
    ASSIGNMENT_MANUAL: `${FILE_REPO_URL_STG}/template/create-manual-card-assignment.csv`,
    MANUAL_CHECK: `${FILE_REPO_URL_STG}/template/template_import_manualcheck.csv`
  },
  production: {}
};

export const ACCEPT_IMPORT = {
  CSV: [".csv"],
  EXCEL: [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel"
  ],
  IMAGE: ["image/*"],
  PDF: ["application/pdf"],
  TEXT_LIST: [
    {
      text: `
        ONLY upload CSV files with the following columns:<br>
        <ul>
          <li>office_code</li>
          <li>rate_regular</li>
          <li>rate_ro</li>
        </ul>`
    },
    {
      text:
        "Except CSV file with correct columns, others will not be process by system."
    }
  ]
};

const USER_FLAG = {
  F1: "1", // 'Admin'
  F2: "2", // 'MRC, MRP, MRO, MAC'
  F3: "3", // 'AO, SAO'
  F4: "4", // 'CRH, CSH, CAC, CAP'
  F5: "5", // 'CRE'
  F6: "6", // 'MRA, SF, MCE'
  F7: "7", // 'Conditional'
  F8: "other" // 'External, CC, PV'
};

const LIST_USER_FLAG = [
  USER_FLAG.F1,
  USER_FLAG.F2,
  USER_FLAG.F3,
  USER_FLAG.F4,
  USER_FLAG.F5,
  USER_FLAG.F6,
  USER_FLAG.F7,
  USER_FLAG.F8
];

export const FLAG_ADMIN = [...LIST_USER_FLAG].filter(d => d == USER_FLAG.F1);
export const FLAG_MRO = [...LIST_USER_FLAG].filter(d => d == USER_FLAG.F2);
export const FLAG_ALL = [...LIST_USER_FLAG];
export const FLAG_EXCEPT_6 = [...LIST_USER_FLAG].filter(d => d != USER_FLAG.F6);
export const FLAG_1_8 = [...LIST_USER_FLAG].filter(
  d => d == USER_FLAG.F1 || d == USER_FLAG.F8
);
export const FLAG_1_2 = [...LIST_USER_FLAG].filter(
  d => d == USER_FLAG.F1 || d == USER_FLAG.F2
);

export const RED_FLAG = {
  NO: 0,
  PHONE_UPDATE: 1,
  DUKCAPIL: 2,
  FR_LIVENESS: 3,
  TENOR: 4,
  ALL: 99
};

export const TABLE_HEADER = {
  MEMBERSHIP: [
    { text: "No", align: "start", sortable: false, value: "no" },
    {
      text: "Member Id",
      align: "start",
      sortable: false,
      value: "id",
      width: "96px"
    },
    { text: "Name", value: "name", width: "150px" },
    { text: "Customer No", value: "custNo" },
    { text: "Cust Main No", value: "custMainNo" },
    { text: "Card No", value: "cardNo" },
    { text: "Phone No", value: "phone" },
    { text: "Branch", value: "branch" },
    { text: "Status", value: "status" }
  ],
  MEMBERSHIP_NATIONAL: [
    { text: "No", align: "start", sortable: false, value: "no" },
    { text: "Name", value: "name", width: "150px" },
    { text: "Customer No", value: "custNo" },
    { text: "Cust Main No", value: "custMainNo" },
    { text: "Card No", value: "cardNo" },
    { text: "Phone No", value: "phone" },
    { text: "Branch", value: "branch" },
    { text: "Status", value: "status" }
  ],
  MEMBERSHIP_EMPLOYEE: [
    { text: "No", align: "start", sortable: false, value: "no" },
    { text: "NPK", value: "npk", width: "150px" },
    {
      text: "NIK",
      align: "start",
      sortable: false,
      value: "nik",
      width: "96px"
    },
    { text: "Phone No", value: "phone" },
    { text: "Email", value: "email" },
    { text: "Status", value: "status" }
  ],
  DATABASE_TYPE_HISTORY: [
    {
      text: "Old Database Type",
      align: "center",
      value: "databaseTypeOld",
      sortable: false
    },
    {
      text: "New Database Type",
      align: "center",
      value: "databaseTypeNew",
      sortable: false
    },
    {
      text: "Reset By",
      align: "center",
      value: "resetBy",
      sortable: false
    },
    {
      text: "Reset Date",
      align: "center",
      value: "resetDate",
      sortable: false
    }
  ],
  PAYMENT_HISTORY: [
    {
      value: "contractNo",
      text: "No Kontrak",
      align: "center",
      sortable: false
    },
    {
      text: "Installment No",
      value: "installmentNo",
      align: "center",
      sortable: false
    },
    {
      text: "Angsuran",
      align: "center",
      value: "angsuran",
      sortable: false
    },
    {
      align: "center",
      text: "Principle",
      value: "principal",
      sortable: false
    },
    {
      value: "interest",
      text: "Interest",
      align: "center",
      sortable: false
    },
    {
      text: "Balance Plafond",
      align: "center",
      value: "plafond",
      sortable: false
    },
    {
      value: "principlePaidDate",
      text: "Paid Date",
      align: "center",
      sortable: false
    }
  ],
  PHONE_NO_HISTORY: [
    {
      text: "Old Phone Number",
      align: "center",
      value: "phoneOld",
      sortable: false
    },
    {
      text: "New Phone Number",
      align: "center",
      value: "phoneNew",
      sortable: false
    },
    {
      text: "CS ID",
      align: "center",
      value: "csId",
      sortable: false
    },
    {
      text: "Reset Date",
      align: "center",
      value: "registerDate",
      sortable: false
    },
    {
      text: "Channel",
      align: "center",
      value: "source",
      sortable: false
    },
    {
      text: "Selfie Photo",
      align: "center",
      value: "selfiePhotoPath",
      sortable: false,
      width: "240px"
    }
  ],
  EMAIL_HISTORY: [
    {
      value: "emailOld",
      text: "Old Email",
      align: "center",
      sortable: false
    },
    {
      value: "emailNew",
      text: "New Email",
      align: "center",
      sortable: false
    },
    {
      value: "registerDate",
      text: "Register Date",
      align: "center",
      sortable: false
    },
    {
      value: "verificationDate",
      text: "Verification Date",
      align: "center",
      sortable: false
    }
  ],
  BRANCH_HISTORY: [
    {
      text: "Old Branch",
      align: "center",
      value: "branchOld",
      sortable: false
    },
    {
      text: "New Branch",
      align: "center",
      value: "branchNew",
      sortable: false
    },
    {
      text: "Change Date",
      align: "center",
      value: "creationDate",
      sortable: false
    }
  ],
  PO_STATUS: {
    SALES_COLUMN: [
      { text: "No", value: "no", sortable: false },
      { text: "Appl No. / PO NO.", value: "applNo", width: "150px" },
      { text: "Customer", value: "memberName" },
      { text: "Tipe Customer", value: "customerType" },
      { text: "Purchase Date", value: "purchaseDate" },
      { text: "Sf Id", value: "salesCode" },
      { text: "Status", value: "status" }
    ],
    NON_SALES_COLUMN: [
      { text: "No", value: "no", sortable: false },
      { text: "Appl No. / PO NO.", value: "applNo", width: "150px" },
      { text: "Customer", value: "memberName" },
      { text: "Tipe Customer", value: "customerType" },
      { text: "Central", value: "central" },
      { text: "Purchase Date", value: "purchaseDate" },
      { text: "Platform", value: "platform", sortable: false },
      { text: "Source Order", value: "sourceInput" },
      { text: "Red Flag", value: "redFlag" },
      { text: "IAS", value: "ias" },
      { text: "Status", value: "status" }
    ]
  },
  ASSIGNMENT_HISTORY: [
    {
      text: "Remark Date",
      align: "center",
      value: "creationDate",
      sortable: true
    },
    {
      text: "Remark",
      align: "center",
      value: "remark",
      sortable: false
    },
    {
      text: "Remark By",
      align: "center",
      value: "remarkBy",
      sortable: false
    }
  ]
};

export const CARD_STATUS = [
  {
    code: null,
    name: "All Status",
    secureId: null
  },
  {
    name: "Issued",
    code: null,
    secureId: "Issued"
  },
  {
    secureId: "Printing",
    code: null,
    name: "Printing"
  },
  {
    name: "Delivered to Branch",
    code: null,
    secureId: "delivered_to_branch"
  },
  {
    code: null,
    secureId: "Branch",
    name: "Branch"
  },
  {
    name: "MRA",
    code: null,
    secureId: "MRA"
  },
  {
    secureId: "delivered_to_customer",
    name: "Delivered to Customer",
    code: null
  },
  {
    secureId: "Customer",
    name: "Customer",
    code: null
  },
  {
    code: null,
    name: "Lost",
    secureId: "Lost"
  },
  {
    code: null,
    name: "Cancelled",
    secureId: "Cancelled"
  },
  {
    code: null,
    secureId: "Digital",
    name: "Digital"
  },
  {
    name: "Digital PWA",
    code: null,
    secureId: "digital_pwa"
  },
  {
    code: null,
    name: "Picked-Up",
    secureId: "Picked_Up"
  }
];

export const CARD_REQUEST_SOURCE = [
  {
    code: null,
    name: "- All -",
    secureId: null
  },
  {
    code: "CMA",
    secureId: "CMA",
    name: "CMA"
  },
  {
    name: "CMS",
    secureId: "CMS",
    code: "CMS"
  },
  {
    name: "FIFADA",
    code: "FIFADA",
    secureId: "FIFADA"
  },
  {
    name: "FIONA",
    secureId: "FIONA",
    code: "FIONA"
  },
  {
    code: "WEBSITE_FIFGROUP",
    name: "Website FIFGROUP",
    secureId: "WEBSITE_FIFGROUP"
  },
  {
    name: "FMC",
    code: "FMC",
    secureId: "FMC"
  },
  {
    name: "PWA Browser",
    code: "PWA_BROWSER",
    secureId: "PWA_BROWSER"
  },
  {
    code: "ISS",
    name: "ISS",
    secureId: "ISS"
  },
  {
    code: "FIFADA_TRANSACTION",
    name: "FIFADA TRANSACTION",
    secureId: "FIFADA_TRANSACTION"
  },
  {
    name: "FIFADA ACTIVATION",
    secureId: "FIFADA_ACTIVATION",
    code: "FIFADA_ACTIVATION"
  },
  {
    name: "FMSALES SPEKTRA",
    code: "FM_SALES_SPEKTRA",
    secureId: "FM_SALES_SPEKTRA"
  },
  {
    code: "FM_SALES_UFI",
    secureId: "FM_SALES_UFI",
    name: "FMSALES UFI"
  },
  {
    name: "WEB TRANSACTION",
    code: "WEB_TRANSACTION",
    secureId: "WEB_TRANSACTION"
  },
  {
    code: "B2B_NMC",
    secureId: "B2B_NMC",
    name: "B2B NMC"
  },
  {
    name: "EFORM",
    code: "EFORM_TRANSACTION",
    secureId: "EFORM_TRANSACTION"
  }
];
